// extracted by mini-css-extract-plugin
module.exports = {"statusWrapper":"Status_statusWrapper__3DzvR","coloredDot":"Status_coloredDot__KDDYx","label":"Status_label__FYze1"};